var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgYellowLinkin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    xmlns: "http://www.w3.org/2000/svg",
    heightviewbox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25 23.75h-3.75v-7.004c0-4.21-5-3.894-5 0v7.004H12.5V10h3.75v2.207C17.996 8.973 25 8.734 25 15.301v8.449zM8.125 8.414a2.195 2.195 0 01-2.188-2.203c0-1.219.981-2.207 2.188-2.207 1.207 0 2.188.988 2.188 2.207 0 1.219-.981 2.203-2.188 2.203zM10 23.75H6.25V10H10zM23.75 0H6.25A6.248 6.248 0 000 6.25v17.5A6.25 6.25 0 006.25 30h17.5A6.25 6.25 0 0030 23.75V6.25A6.248 6.248 0 0023.75 0",
    fill: "#FFEC55"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYellowLinkin);
export default __webpack_public_path__ + "static/media/Yellow-Linkin.1ba70a262f4b0e72871efb82b0dd525e.svg";
export { ForwardRef as ReactComponent };